import { ToastContainer } from "react-toastify";

import MasterLayout from "./layouts/MasterLayout";
import { AuthContextProvider } from "./contexts/AuthContext";
import { Container, Row, Col } from "react-bootstrap";

import "./App.scss";
import "react-toastify/dist/ReactToastify.css";

function App() {
  //const { isLoggedIn, setIsLoggedIn } = useAuthContext();

  return (
    <AuthContextProvider>
      {/* <AppContextProvider> */}
      <Container fluid>
        <Row>
          <Col sm={12}>
            <MasterLayout />
          </Col>
        </Row>

        <ToastContainer
          position="bottom-left"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Container>
      {/* </AppContextProvider> */}
    </AuthContextProvider>
  );
}

export default App;
